import { render, staticRenderFns } from "./DataDrivenComponent.vue?vue&type=template&id=5d345f10&"
import script from "./DataDrivenComponent.vue?vue&type=script&lang=ts&"
export * from "./DataDrivenComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports